'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getGates = undefined;

var _reselect = require('reselect');

var _get = require('transmute/get');

var _get2 = _interopRequireDefault(_get);

var _getLatestWidgetData = require('../../widget-data/selectors/getLatestWidgetData');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getGates = exports.getGates = (0, _reselect.createSelector)([_getLatestWidgetData.getLatestWidgetData], (0, _get2.default)('gates'));